/** Lazy routes. Not part of router.tsx due to fast refresh lint */

import { SuspenseBusy, withSuspense } from '@tunasong/ui-lib'
import React from 'react'
import type { FC } from 'react'

export const LazyLogin = withSuspense(
  React.lazy(async () => import('./auth/login.js')),
  <SuspenseBusy />
)

export const LazyErrorBoundary = withSuspense(
  React.lazy(async () => import('./error-boundary.js')),
  <SuspenseBusy />
)

export const LazyPage = withSuspense(
  React.lazy(async () => import('./pages/page.js')),
  <SuspenseBusy />
)

export const LazyTermsOfService = withSuspense(
  React.lazy(async () => import('./pages/terms-of-service.js')),
  <SuspenseBusy />
)

export const LazyWaitlistPage = withSuspense(
  React.lazy(async () => import('./pages/waitlist.js')),
  <SuspenseBusy />
)

export const LazyEmbed = withSuspense(
  React.lazy(async () => import('./pages/embed.js')),
  <SuspenseBusy />
)

export const LazyIndexPage = withSuspense(
  React.lazy(async () => import('./pages/index.js')),
  <SuspenseBusy />
)

export const LazyLogout = withSuspense(
  React.lazy(async () => import('./auth/logout.js')),
  <SuspenseBusy />
)

export const LazyLabs: FC = withSuspense(
  React.lazy(async () => import('@tunasong/labs')),
  <SuspenseBusy />
)

export const LazyRootMain = withSuspense(
  React.lazy(async () => {
    const { RootMain } = await import('@tunasong/tunasong-ui')
    return { default: RootMain }
  }),
  <SuspenseBusy />
)

export const LazyProfile = withSuspense(
  React.lazy(async () => {
    const { Profile } = await import('@tunasong/tunasong-ui')
    return { default: Profile }
  }),
  <SuspenseBusy />
)

export const LazyAudioMixer = withSuspense(
  React.lazy(async () => {
    const { AudioMixer } = await import('@tunasong/audio-ui')
    return { default: AudioMixer }
  }),
  <SuspenseBusy />
)

export const LazyFavoritiesPage = withSuspense(
  React.lazy(async () => import('./pages/favorities.js').then(m => ({ default: m.FavoritiesPage }))),
  <SuspenseBusy />
)

export const LazyMusicTheoryPage = withSuspense(
  React.lazy(async () => import('./pages/music-theory-page.js').then(m => ({ default: m.MusicTheoryPage }))),
  <SuspenseBusy />
)

export const LazyModeLabPage = withSuspense(
  React.lazy(async () => import('./pages/mode-lab-page.js').then(m => ({ default: m.ModeLabPage }))),
  <SuspenseBusy />
)

export const LazyFunctionQuizPage = withSuspense(
  React.lazy(async () => import('./pages/function-quiz-page.js').then(m => ({ default: m.FunctionQuizPage }))),
  <SuspenseBusy />
)

export const LazyReharmLabPage = withSuspense(
  React.lazy(async () => import('./pages/reharm-lab-page.js').then(m => ({ default: m.ReharmLabPage }))),
  <SuspenseBusy />
)

export const LazyGuitarPatternsPage = withSuspense(
  React.lazy(async () => import('./pages/guitar-patterns-page.js').then(m => ({ default: m.GuitarPatternsPage }))),
  <SuspenseBusy />
)

export const LazyGuitarChordsPage = withSuspense(
  React.lazy(async () => import('./pages/guitar-chords-page.js').then(m => ({ default: m.GuitarChordsPage }))),
  <SuspenseBusy />
)

export const LazyExternalToolPage = withSuspense(
  React.lazy(async () => import('./pages/external-tool-page.js').then(m => ({ default: m.ExternalToolPage }))),
  <SuspenseBusy />
)

export const LazyGamesPage = withSuspense(
  React.lazy(async () => import('./pages/games.js').then(m => ({ default: m.GamesPage }))),
  <SuspenseBusy />
)

export const LazyRouterAppChrome = withSuspense(
  React.lazy(async () => import('./router-entity-container.js').then(m => ({ default: m.RouterAppChrome }))),
  <SuspenseBusy />
)

export const LazyRouterAppGroupChrome = withSuspense(
  React.lazy(async () => import('./router-entity-group-container.js').then(m => ({ default: m.RouterAppGroupChrome }))),
  <SuspenseBusy />
)
